import { createPortal } from 'react-dom';
import { usePageBottomPortal } from './PageBottomPortalContext';

const PageBottomPortal = ({ children }: { children: React.ReactNode }) => {
  const containerRef = usePageBottomPortal();

  if (!containerRef.current) {
    return null;
  }

  return createPortal(children, containerRef.current);
};

export default PageBottomPortal;
